export default "__VITE_ASSET__C3NAu24R__"